<template>
  <KpiScrollWrapper>
    <KpiComponent
      :label="`Totaal factuurbedrag ${monthLabel}`"
      :value="invoiceTotal"
      format="€ _"
      :precision="2"
      icon="money-euro-circle"
      icon-color="finance"
    >
      <template #description="{ label }">
        {{ label }}
        <span v-if="monthRecord && !isDefinitive" class="text-warning-600">
          · Voorlopig bedrag
        </span>
      </template>
    </KpiComponent>

    <KpiComponent
      :label="`Totaal marktresultaat ${monthLabel}`"
      :value="marketTotal"
      format="€ _"
      :precision="2"
      icon="line-chart"
      icon-color="finance"
    >
      <template #description="{ label }">
        <span class="inline-flex items-center gap-1.5">
          {{ label }}
          <BaseTooltip
            description="Exclusief kosten, belastingen en overige verrekeningen. Dit zijn alleen de resultaten uit de energiemarkten. Op de uiteindelijke factuur worden hier nog kosten, belastingen en andere verrekeningen op toegepast."
          >
            <BaseIcon
              name="information"
              filled
              class="text-sm text-gray-400"
              aria-hidden="true"
            />
          </BaseTooltip>
        </span>
        <span
          v-if="marketTotal != null && !isMarketDefinitive"
          class="text-warning-600"
        >
          · Voorlopig bedrag
        </span>
      </template>
    </KpiComponent>
  </KpiScrollWrapper>
</template>

<script setup>
import { BaseIcon, BaseTooltip } from "@repowerednl/ui-component-library"
import KpiComponent from "@/components/information/KpiComponent.vue"
import KpiScrollWrapper from "@/components/utilities/KpiScrollWrapper.vue"

defineProps({
  monthLabel: {
    type: String,
    required: true,
  },
  monthRecord: {
    type: Object,
    default: null,
  },
  invoiceTotal: {
    type: Number,
    default: null,
  },
  isDefinitive: Boolean,
  marketTotal: {
    type: Number,
    default: null,
  },
  isMarketDefinitive: Boolean,
})
</script>
